import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  dark?: boolean;
}

export default function Breadcrumb({ items, dark = false }: BreadcrumbProps) {
  return (
    <nav
      aria-label="面包屑导航"
      className={`flex flex-wrap items-center gap-1.5 text-xs ${dark ? "text-primary-300" : "text-foreground-500"}`}
    >
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
          {item.to ? (
            <Link
              to={item.to}
              className={`transition-colors ${dark ? "hover:text-accent-300" : "hover:text-primary-600"}`}
            >
              {item.label}
            </Link>
          ) : (
            <span className={dark ? "text-background-100" : "text-foreground-800"}>{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className={`ri-arrow-right-s-line ${dark ? "text-primary-500" : "text-foreground-300"}`}></i>
          )}
        </span>
      ))}
    </nav>
  );
}